import React, { useState, useEffect } from "react";
import { makeRequest } from "../../../utils/makeRequest";
import { getTermsAndConditionsURL } from "../../../utils/urls";

const TermsAndConditions = () => {
    const [terms, setTerms] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchTerms = async () => {
        try {
            const response = await makeRequest(`${getTermsAndConditionsURL}`, 'GET');
            console.log("Terms response", response);

            if (response.success && response.data?.terms?.content) {
                setTerms(response.data?.terms?.content);
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            console.error("Error fetching terms and conditions:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTerms();
    }, []);


    return (
        <div>
            <nav className="navbar navbar-light bg-light shadow-sm px-3">
                <div className="container d-flex align-items-center justify-content-between">
                    <a className="navbar-brand fw-bold" href="/">Payserve</a>
                    <div>
                        <a className="mx-3 text-decoration-none text-dark fw-bold" href="/">Home</a>
                        <a className="text-decoration-none text-dark fw-bold" href="/terms_and_conditions">Terms and Conditions</a>
                    </div>
                    <div className="invisible navbar-brand"></div>
                </div>
            </nav>
            <div className="container my-5" style={{ minHeight: "75vh", maxWidth: "95%" }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-11 col-sm-12">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h3 className="mb-4 text-center fw-bold text-primary">
                                    Terms and Conditions
                                </h3>

                                {loading ? (
                                    <p className="text-center text-muted">Loading terms and conditions...</p>
                                ) : (
                                    <div
                                        className="text-muted"
                                        style={{
                                            lineHeight: "1.8",
                                            whiteSpace: "pre-line",
                                            fontSize: "15px",
                                        }}
                                        dangerouslySetInnerHTML={{ __html: terms }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
